module.exports = __webpack_public_path__ + "media/bootstrap-icons/bell-fill-b93ae571.svg";